import { PayloadAction } from '@reduxjs/toolkit';

import { DesignData } from 'editor/src/store/design/types';
import getDesignKey, { getDesignKeyFromDesign } from 'editor/src/store/variants/helpers/getDesignKey';
import { VariantsState } from 'editor/src/store/variants/types';

import reflectDesignData from 'editor/src/util/reflectDesignData';
import { ReflectContext } from 'editor/src/util/reflectDesignData/getReflectContext';

import { UNSELECTED_PAGE_COUNT } from './setPageCountReducer';

const setGroupDesignDataReducer = (
  state: VariantsState,
  action: PayloadAction<{
    groupKey: string;
    designData: DesignData | undefined;
    reflectContext: ReflectContext;
  }>,
) => {
  const { groupKey, designData, reflectContext } = action.payload;
  const group = state.variationGroups.find((group) => group.key === groupKey);
  if (group) {
    const { selectedPageCount } = state;
    const designDataKey = designData ? getDesignKeyFromDesign(designData) : undefined;
    group.variationsInfo.forEach((variationInfo) => {
      const designKey = getDesignKey(variationInfo.variation.productUid, {
        ...variationInfo,
        pageCount: selectedPageCount === UNSELECTED_PAGE_COUNT ? undefined : selectedPageCount,
      });
      if (designKey === designDataKey) {
        variationInfo.designData = designData;
      } else {
        const template = state.designTemplates[designKey];
        // GAPI-39157: Don't overwrite existing designData when the template for
        // THIS variant has a different spread count than the incoming designData.
        // This happens when "Apply changes to all variants" propagates a 2-spread
        // design (two-sided flyer) onto a 1-spread variant (one-sided flyer).
        // reflectDesignData would produce output matching the template's spread
        // count, but we skip it entirely because the variant already has correct
        // designData and the incoming design is structurally incompatible.
        // Guard only fires when all three exist: prior designData, template, AND
        // incoming designData — if any is missing, we still want reflection to run.
        const spreadCountMismatch =
          variationInfo.designData &&
          template &&
          designData &&
          template.spreads.length !== designData.spreads.length;
        if (!spreadCountMismatch) {
          const reflected = designData && template ? reflectDesignData(designData, template, reflectContext) : undefined;
          if (reflected !== undefined) {
            variationInfo.designData = reflected;
          }
        }
      }
    });
  }
};

export default setGroupDesignDataReducer;
